/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import pluralize from 'cio/utils/pluralize';

import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

interface ManageTranslationsArgs {
  editableEntity: ComposerEditableEntity;
  onClose: (e?: MouseEvent) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class ManageTranslations extends Component<ManageTranslationsArgs> {
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;

  addLanguageTranslations = task(async (languages: string[]) => {
    try {
      await this.args.editableEntity.addLanguageTranslations(languages);

      this.alerts.success(
        'translation.creation.success',
        `${languages.length} language ${pluralize(
          languages.length,
          'variation',
        )} added. Access them in the tabs below.`,
      );
    } catch {
      this.alerts.error(
        'translation.creation.failure',
        'Something went wrong when trying to add your translations. Please try again or contact support for help.',
      );
    } finally {
      this.args.onClose();
    }
  });

  @action
  close(e: MouseEvent) {
    this.analytics.track('languages', 'add_language_canceled', {
      ...this.args.editableEntity.analyticsData,
    });
    this.args.onClose(e);
  }

  @action
  onAttributeInfoIconHover() {
    this.analytics.track('languages', 'attribute_info_icon_hovered', this.args.editableEntity.analyticsData);
  }

  @action
  onSettingsLinkClicked() {
    this.analytics.track('languages', 'settings_link_clicked', this.args.editableEntity.analyticsData);
  }
}
